import axios from 'axios';
export const proxyApiRequest = async (url, data) => {
	return await axios.post(url, data, {
		headers: {
			client_id: process.env.REACT_APP_CLIENT_ID,
			client_secret: process.env.REACT_APP_CLIENT_SECRET,
			source_system: process.env.REACT_APP_SOURCE_SYSTEM,
		},
	});
};
